import React from 'react'
import mount from '../lib/mount'
import App from '../components/App'
import NewJob from '../components/NewJob'

document.addEventListener('turbolinks:load', () => {
  const el = document.getElementById('react-new-job')
  if (el) {
    const data = JSON.parse(el.getAttribute('data'))
    mount(
      el,
      <App>
        <NewJob
          stripePublishable={data.stripePublishable}
          cost={data.cost}
          />
      </App>,
    )
  }
})
